// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AvatarFromImage {
    export const isExternalUrl = (url) => {
        // Verifica si la URL es un blob
        if (url.startsWith('blob:')) {
            return false;
        }
        // Verifica si la URL es externa
        try {
            const parsedUrl = new URL(url);
            return parsedUrl.origin !== window.location.origin;
        } catch (error) {
            // Si la URL no es válida, asumimos que es una URL interna relativa
            return false;
        }
    };

    export const getAvatarUrl = (url) => {
        if (!url) {
            return undefined;
        }

        if (isExternalUrl(url)) {
            return url;
        }
        return url.startsWith('blob:') ? url : `${process.env.REACT_APP_API_URL_MS_AUTH}${url}`;
    };


    export const getValidImageUrlFromArray = (images: string[]): string | null => {

        // debugger;
        for (const image of images) {
            const avatarUrl = getAvatarUrl(image);
            if (avatarUrl) {
                return avatarUrl;
            }
        }

        // Si no se encuentra ninguna imagen válida, devuelve null
        return null;
    };
}